import styled from "styled-components";

function ProfileItem({image, name, writer, publisher, publishedDate}){
    return(
        <Container>
            <CoverImage src={image} alt="cover_image"/>
            <Content>
                <Name>{name}</Name>
                <DataWithLabel>저자 <Data>{writer}</Data></DataWithLabel>
                <Footer>
                    <DataWithLabel>출판 <Data>{publisher}</Data></DataWithLabel>
                    <DataWithLabel>발행 <Data>{publishedDate}</Data></DataWithLabel>
                </Footer>
            </Content>
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`

const CoverImage = styled.img`
`

const Content = styled.div`
    display: flex;
    flex-direction: column;
    padding: 20px 10px;
    gap: 10px;
`

const Name = styled.div`
    font-size: 20px;
    font-weight: 700;
`

const DataWithLabel = styled.div`
    font-size: 16px;
    color: #555;
    display: flex;
    align-items: center;
    gap: 10px;
`

const Data = styled.div`
    color: black;
    font-size: 14px;
`

const Footer = styled.div`
    display: flex;
    justify-content: space-between;
`

export default ProfileItem;